import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../Accordion';
import { SessionCard } from './SessionCard';
import type { WebinarGroup } from '../../data/webinars';
import { isPastSession } from '../../utils/webinars';
type SupplementarySeriesProps = {
  groups: WebinarGroup[];
  nextSessionId?: string;
  /** Group opened by default — used to reveal search matches. */
  defaultOpenGroupId?: string;
};
export function SupplementarySeries({
  groups,
  nextSessionId,
  defaultOpenGroupId
}: SupplementarySeriesProps) {
  if (groups.length === 0) return null;
  return <section aria-labelledby="supplementary-heading" className="w-full bg-tint py-24 sm:py-28 lg:py-[120px]" data-id="element-72" data-mp="3e5aushnz17yv">
      <div className="mx-auto w-full max-w-[1280px] px-6 sm:px-10" data-id="element-73" data-mp="396hdsf9h6yty">
        <header data-id="element-74" data-mp="1jq89yx9vae2a">
          <p className="text-[15px] font-semibold uppercase tracking-[0.14em] text-brand" data-id="element-75" data-mp="1jrt4imw6lx05">
            Supplementary
          </p>
          <h2 id="supplementary-heading" className="mt-5 font-heading text-[32px] font-bold leading-[1.15] tracking-tight text-ink sm:text-[38px] lg:text-[44px]" data-id="element-76" data-mp="1eu1ejyf3kkyl">
            Supplementary Webinar Series
          </h2>
        </header>

        <Accordion key={defaultOpenGroupId ?? 'default'} type="single" collapsible defaultValue={defaultOpenGroupId} className="mt-14 w-full space-y-5 lg:mt-16" data-id="element-77" data-mp="q3twqssftluw">
          {groups.map(group => <AccordionItem key={group.id} value={group.id} className="overflow-hidden rounded-[16px] border border-hairline bg-white shadow-card last:border-b" data-id="element-78" data-mp="13vqm4p2q1hnl">
              <AccordionTrigger className="gap-6 px-7 py-7 text-left hover:no-underline sm:px-9" data-id="element-79" data-mp="1dug3mgqph03b">
                <span className="flex flex-col gap-2" data-id="element-80" data-mp="3an86d0tv2e8a">
                  <span className="text-[15px] font-semibold uppercase tracking-[0.14em] text-brand" data-id="element-81" data-mp="3aot0wqg6dx65">
                    {group.eyebrow}
                  </span>
                  <span className="font-heading text-[22px] font-bold leading-snug tracking-tight text-ink sm:text-[24px]" data-id="element-82" data-mp="37lmwxmc47s4u">
                    {group.title}
                  </span>
                  <span className="max-w-[650px] text-[16px] font-normal leading-relaxed text-body" data-id="element-83" data-mp="3hk2lbhjrcnan">
                    {group.description}
                  </span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="px-7 pb-9 sm:px-9" data-id="element-84" data-mp="3qi4syfxzye6w">
                <ul className="grid grid-cols-1 gap-7 border-t border-hairline pt-9 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8" data-id="element-85" data-mp="3ll5yfwaf8586">
                  {group.sessions.map(session => <li key={session.id} className="flex" data-id="element-86" data-mp="3vapl7d198j8b">
                      <SessionCard session={session} isNext={session.id === nextSessionId} isPast={isPastSession(session)} data-id="element-87" data-mp="3vb7q0y1zg5ru" />
                    </li>)}
                </ul>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}